// #1637 — design §8.2's curated scoreboard font set, self-hosted via
// @fontsource/* (no runtime dependency on fonts.googleapis.com — venue
// internet is unreliable and the board must not depend on it). The set
// itself is a constant per the design doc ("extending it is a one-line
// card"); this module is that constant plus the CSS imports that actually
// bundle the font files into the app.
//
// Key casing: kebab-case-of-the-@fontsource-package-name, e.g. `inter`,
// `roboto-condensed`. Card #1640's theme editor (design §8.3) writes these
// same keys via FONT_OPTIONS below, so this module stays the single source
// of truth both sides read from — the editor never invents its own casing.
import "@fontsource/inter";
import "@fontsource/roboto-condensed";
import "@fontsource/oswald";
import "@fontsource/montserrat";
import "@fontsource/archivo";
import "@fontsource/bebas-neue";
import "@fontsource/barlow-condensed";
import "@fontsource/lora";

export const DEFAULT_FONT_KEY = "inter";

const FONT_FAMILY_BY_KEY = {
  inter: "'Inter', sans-serif",
  "roboto-condensed": "'Roboto Condensed', sans-serif",
  oswald: "'Oswald', sans-serif",
  montserrat: "'Montserrat', sans-serif",
  archivo: "'Archivo', sans-serif",
  "bebas-neue": "'Bebas Neue', sans-serif",
  "barlow-condensed": "'Barlow Condensed', sans-serif",
  lora: "'Lora', serif",
};

const FONT_LABEL_BY_KEY = {
  inter: "Inter",
  "roboto-condensed": "Roboto Condensed",
  oswald: "Oswald",
  montserrat: "Montserrat",
  archivo: "Archivo",
  "bebas-neue": "Bebas Neue",
  "barlow-condensed": "Barlow Condensed",
  lora: "Lora",
};

// Unknown/absent fontKey falls back to the curated default rather than
// leaving `font-family` empty (which would silently hand the board to
// whatever generic font the browser/OS happens to pick).
export function resolveFontFamily(fontKey) {
  return FONT_FAMILY_BY_KEY[fontKey] || FONT_FAMILY_BY_KEY[DEFAULT_FONT_KEY];
}

// Card #1640 — the theme editor's font picker: one entry per curated font,
// `family` is exactly what resolveFontFamily(key) would return, so the
// picker's live sample renders in the SAME font-family string the board
// itself will end up using (no drift between "what the editor shows" and
// "what the board applies").
export const FONT_OPTIONS = Object.keys(FONT_FAMILY_BY_KEY).map((key) => ({
  key,
  label: FONT_LABEL_BY_KEY[key],
  family: FONT_FAMILY_BY_KEY[key],
}));
